import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import CKEditor from '@ckeditor/ckeditor5-vue';
import IdleVue from "idle-vue";
import VueHorizontalTimeline from "vue-horizontal-timeline";
//import VeeValidate from 'vee-validate'
 
const eventsHub = new Vue();
 
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 2500000, // 3 segundos,
  //idleTime: 3000, // 3 segundos,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
  startAtIdle: false
});

Vue.use( 
  CKEditor,
 // Vidle
);

Vue.config.productionTip = false;
Vue.use(VueHorizontalTimeline);
//Vue.use(VeeValidate);
//axios.defaults.baseURL='sistemapruebasogl/'
//axios.defaults.baseURL='SISTEMAOGLDEMO/'
axios.defaults.baseURL='SISTEMAOPTIMAGL/';
//axios.defaults.baseURL='http://localhost:53952/'
new Vue({
  CKEditor,
  router,
  store,
  IdleVue,
  vuetify,
  render: h => h(App)
}).$mount('#app')



